export default "__VITE_ASSET__Tf_p8dnB__"